import { React, Component, Container, Route, _ } from 'utils';
import {withRouter} from 'react-router-dom';
import { App, FairStore, SelectedPavilionStore, AboutStore, Creators } from 'model';
import { Pie } from "react-chartjs-2";
import Slider from "react-slick";
import './about.less';

class About extends Component {

	static getStores() {
		return [ AboutStore ];
	}

	static calculateState() {
		return AboutStore.getState();
	}

	state = { data: {} }

	componentDidMount() {
		const {pavilion, stand} = this.props.match.params;
		Creators.loadAbout(pavilion, stand);
	}

	componentWillMount()
	{
		document.addEventListener("keydown", this.handleArrows);
	}

	componentWillUnmount()
	{
		document.removeEventListener("keydown", this.handleArrows);
	}

	handleArrows = (event) => {
		if (event.keyCode === 37 && this.slider)
			this.slider.slickPrev();
		if (event.keyCode === 39 && this.slider)
			this.slider.slickNext();
	};

	adder = (accumulator, currentValue) => {
		if (typeof currentValue === "number")
			return accumulator + currentValue;
		return accumulator;
	};

	renderPie(config)
	{
		let total = config.data.reduce(this.adder, 0);
		if (total > 0) {
			return (
				<Pie
					height={170}
					data={{
						labels: config.labels,
						datasets: [{
							data: config.data,
							backgroundColor: config.backgroundColor,
						}]
					}}
					options={{
						legend: {
							position: "right",
							labels: { boxWidth: 10 },
						},
						title: {
							display: true,
							text: config.title,
						},
					}}
				/>
			);
		}
	}

	render() {
		const { data } = this.state;
		const genderData = [
			data.employeeGenderFemale,
			data.employeeGenderMale,
		];
		const ageData = [
			data.employeeAge30,
			data.employeeAge3140,
			data.employeeAge4150,
			data.employeeAgeOver50,
		];
		const educationData = [
			data.employeeQualificationSchool,
			data.employeeQualificationHighschool,
			data.employeeQualificationCollege,
			data.employeeQualificationPhd,
		];

		// Let's check if we can render every card and its subparts
		const canRenderCharts = (
			ageData.reduce(this.adder, 0) ||
			genderData.reduce(this.adder, 0) ||
			educationData.reduce(this.adder, 0)
		) > 0;
		const canRenderStandInfo = !!data.standInfos && !!data.standInfos.length;
		const canRenderContactAddress = !!data.address || !!data.location;
		const canRenderContactWebsite = !!data.website;
		const canRenderContactPhone = !!data.contactName || !!data.contactEmail || !!data.phone;
		const canRenderContacts = (
			!!canRenderContactAddress ||
			!!canRenderContactWebsite ||
			!!canRenderContactPhone
		);
		const canRenderProducts = !!data.standProducts && !!data.standProducts.length

		const sliderSettings = {
			dots: true,
			arrows: true,
			accessibility: true
		};

		return (
			<div className="col-md-12 about-activity-box">
				<h1 className="display-4">{_('About Us')}</h1>
				<div className="card">
					<div className="stand-info">
						<div className="image">
							<img src={data.imageUrl} />
						</div>
						<div className="info">
							<h2>{data.title}</h2>
							<span>{data.address}</span>
							<span>{data.location}</span>
							<span>{data.website}</span>
						</div>
					</div>
					<div className="about" dangerouslySetInnerHTML={{ __html: data.about }} />
				</div>
				{canRenderCharts && (
					<div className="card">
						<h2>{_('Employees')}</h2>
						<div className="employees">
							<div>
								{this.renderPie({
									title: _('Sex'),
									labels: [
										_('Female'),
										_('Male'),
									],
									data: genderData,
									backgroundColor: [
										'#d36c70',
										'#78c3f8',
									]
								})}
							</div>
							<div>
								{this.renderPie({
									title: _('Age'),
									labels: [
										_('under 30'),
										_('31-40'),
										_('41-50'),
										_('over 50'),
									],
									data: ageData,
									backgroundColor: [
										'#d36c70',
										'#78c3f8',
										'#ffe596',
										'#bad0a1',
									],
								})}
							</div>
							<div>
								{this.renderPie({
									title: _('Professional qualification'),
									labels: [
										_('PQ School'),
										_('PQ Highschool'),
										_('PQ College'),
										_('PQ Phd'),
									],
									data: educationData,
									backgroundColor: [
										'#d36c70',
										'#78c3f8',
										'#ffe596',
										'#bad0a1',
									]
								})}
							</div>
						</div>
					</div>
				)}
				{canRenderStandInfo && (
					<div className="card">
						<h2>{_('Useful to know about us')}</h2>
						<div className="info-list">
							{data.standInfos.map(info => (
								<div key={info.name} className="item">
									<img src={info.imageUrl} />
									<span>{_(info.name)}</span>
								</div>
							))}
						</div>
					</div>
				)}
				{canRenderContacts && (
					<div className="card">
						<h2>{_('Contact')}</h2>
						<div className="contact-list">
							{canRenderContactAddress && (
								<div className="contact">
									<i className="fa fa-map-marker" aria-hidden="true"></i>
									<div>
										<h3>{_('Address')}</h3>
										<span>{data.address}</span>
										<span>{data.location}</span>
									</div>
								</div>
							)}
							{canRenderContactWebsite && (
								<div className="contact">
									<i className="fa fa-globe" aria-hidden="true"></i>
									<div>
										<h3>{_('Website')}</h3>
										<span>
											<a target="_blank" href={data.website}>{data.website}</a>
										</span>
									</div>
								</div>
							)}
							{canRenderContactPhone && (
								<div className="contact">
									<i className="fa fa-phone" aria-hidden="true"></i>
									<div>
										<h3>{_('Contact')}</h3>
										<span>{data.contactName}</span>
										<span>{data.contactEmail}</span>
										<span>{data.phone}</span>
									</div>
								</div>
							)}
						</div>
					</div>
				)}
				{canRenderProducts && (
					<div className="card">
						<h2>{_('Products and services')}</h2>
						<div className="slider-container">
							<Slider ref={c => (this.slider = c)} {...sliderSettings}>
								{data.standProducts.map(item => (
									<div key={item.id} >
										<a className="slide-page" href={item.documentUrl ? item.documentUrl : item.link} target="_blank"
										   style={{
											   backgroundImage: "url(" + item.imageUrl + ")",
											   display: "table-cell"
										   }}>
											<p>{item.title}</p>
										</a>
									</div>
								))}
							</Slider>
						</div>
					</div>
				)}
			</div>
		);
	}
}

export default withRouter(Container.create (About, { withProps: true }));


// WEBPACK FOOTER //
// ./src/modules/components/activities/about.js